import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import OverviewNav from '../../common/OverviewNav';
import { generalKey, productPageTheme } from '../../config/pageConfig';
export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale } = useRouter();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    const [productDataA, setProductDataA] = useState<any>({});

    useEffect(() => {
        const getProductDataHandle = async () => {
            const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
            setProductDataA(productPageData);
        };
        getProductDataHandle();
    }, []);
    return (
        <>
            <OverviewNav activeTab={'Support'} />
            {productDataA.spuId && <ProductSupport supportData={productDataA.supportData} spuId={productDataA.spuId} theme={productPageTheme} />}
        </>
    );
}
